import { NavLink } from "react-router-dom";

const MenuItem = ({ to, icon, label, children, permission, onNavClick }) => {
    if (permission === false) return null;

    return children ? (
        <>
            <a className="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target={`#collapse-${label}`} aria-expanded="false" aria-controls={`collapse-${label}`}>
                <div className="sb-nav-link-icon"><i className={icon}></i></div>
                {label}
                <div className="sb-sidenav-collapse-arrow"><i className="fas fa-angle-down"></i></div>
            </a>
            <div className="collapse" id={`collapse-${label}`} data-bs-parent="#sidenavAccordion">
                <nav className="sb-sidenav-menu-nested nav">
                    {children}
                </nav>
            </div>
        </>
    ) : (
        <NavLink to={to} className="nav-link" onClick={onNavClick}>
            <div className="sb-nav-link-icon"><i className={icon}></i></div>
            {label}
        </NavLink>
    );
};

export default MenuItem